import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// Subset de MDI con solo los íconos usados (se regenera en cada `npm run build`; en local: npm run icons)
import '@/assets/fonts/mdi/materialdesignicons-subset.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // configuración para usar los íconos de Material Design Icons
    },
});